import styles from "./styles.module.scss"
import { GetStaticProps, NextPage } from "next"
import withHeader from "@/bet-nextv1/utils/withHeader"
import {
    collectionDocument,
    countDocument,
} from "@/core-nextv3/document/document.api"
import { CASINO_SETTING, REVALIDATE_SETTING } from "@/setting/settings"
import { CardLive } from "../CasinoComponents/CardLive"
import { useEffect, useRef, useState } from "react"
import { CardSlot } from "../CasinoComponents/CardSlot"
import {
    IconButton,
    InputAdornment,
    MenuItem,
    Select,
    SelectChangeEvent,
    TextField,
} from "@mui/material"
import { FaArrowUp, FaSearch } from "react-icons/fa"
import { useTranslation } from "next-i18next"
import { PaginationNumber } from "@/component-nextv3/PaginationNumber"
import { calls } from "@/core-nextv3/util/call.api"
import { MdClear } from "react-icons/md"
import { useResponsive } from "@/core-nextv3/util/useResponsive"

const s = require("searchjs")

const CasinoPage: NextPage = ({ lobbies, providers }: any) => 
{
    console.warn(lobbies, providers)
    // console.log("MALDIÇAO", games)
    const [ gamesState, setGamesState ]                 = useState<any>()
    const [ originalGamesState, setOriginalGamesState ] = useState<any>()
    const [ searchString, setSearchString ]             = useState<any>()
    const [ page, setPage ]                             = useState(1)
    const [ totalGames, setTotalGames ]                 = useState<any>()
    const [ selectedProvider, setSelectedProvider ]     = useState<any>("default")
    const [ init, setInit ]                             = useState(false)
    const [ isVisible, setIsVisible ]                   = useState(false)
    const { t }                                         = useTranslation()
    const { isClient }                                  = useResponsive();
    const parentDivRef                                  = useRef<HTMLDivElement | null>(null)




    // useGetAuthToken(AUTH_SETTING, async (data:any) =>
    // {
    //     if(data)
    //     {
    //         const balance = await getBalance(data);
    //         setBalance(balance);
    //     }
    // })

    //let _ = require('lodash');
    const _ = require("lodash-contrib")

    const getGames = async () => 
    {
        const [ result, countResult ] = await calls(
            collectionDocument(
                CASINO_SETTING.merge({
                    page    : page,
                    perPage : 30,
                    orderBy : "id",
                    where   : [
                        {
                            field    : "_level",
                            operator : "==",
                            value    : 2,
                        },
                        {
                            field    : "type.value",
                            operator : "==",
                            value    : "slot",
                        },
                        {
                            field    : "status",
                            operator : "==",
                            value    : true,
                        },
                        ...(selectedProvider && selectedProvider !== "default"
                            ? [
                                {
                                    field    : "name",
                                    operator : "==",
                                    value    : selectedProvider,
                                },
                            ]
                            : []),
                        ...(searchString
                            ? [
                                {
                                    field    : "search",
                                    operator : "array-contains",
                                    value    : searchString,
                                },
                            ]
                            : []),
                    ],
                })
            ),
            countDocument(
                CASINO_SETTING.merge({
                    page    : page,
                    orderBy : "postdate",
                    asc     : false,
                    perPage : 1200,
                    where   : [
                        {
                            field    : "_level",
                            operator : "==",
                            value    : 2,
                        },
                        {
                            field    : "type.value",
                            operator : "==",
                            value    : "slot",
                        },
                        {
                            field    : "status",
                            operator : "==",
                            value    : true,
                        },
                        ...(selectedProvider && selectedProvider !== "default"
                            ? [
                                {
                                    field    : "name",
                                    operator : "==",
                                    value    : selectedProvider,
                                },
                            ]
                            : []),
                        ...(searchString
                            ? [
                                {
                                    field    : "search",
                                    operator : "array-contains",
                                    value    : searchString?.toLowerCase()?.trim(),
                                },
                            ]
                            : []),
                    ],
                })
            )
        )

        if (result?.collection) 
        {
            result?.collection.forEach((item: any) => 
            {
                item.name = item.name.replaceAll("_", " ")
            })
        }

        if (result.status) 
        {
            setGamesState(result?.collection)
            setOriginalGamesState(result?.collection)

            setTotalGames(countResult?.count)
        }

        setInit(true)

    // return [result?.collection, countResult] || []
    }

    useEffect(() => 
    {
        getGames()
    }, [ page, selectedProvider, searchString ])

    // useEffect(() => {
    //   const handleScroll = () => {
    //     if (parentDivRef.current) {
    //       const scrollThreshold = 1300
    //       setIsVisible(parentDivRef.current?.scrollTop > scrollThreshold)
    //     }
    //   }

    //   const parentDiv = parentDivRef.current

    //   if (parentDiv) {
    //     parentDiv.addEventListener('scroll', handleScroll)
    //   }

    //   return () => {
    //     if (parentDiv) {
    //       parentDiv.removeEventListener('scroll', handleScroll)
    //     }
    //   }
    // }, [parentDivRef])

    const handleFilter = (event: SelectChangeEvent) => 
    {
    // let filteredGames: any[] = []
    // gamesState.forEach((game: any) => {
    //   if (game.name == event.target.value) {
    //     filteredGames.push(game)
    //   }
    // })

        // setGamesState(filteredGames)
        setSelectedProvider(event.target.value)
    }

    const handleTextFilter = (event: any) => 
    {
        if (!event.target.value) 
        {
            // setGamesState(originalGamesState)
            setSearchString(null)
            return
        }

        // let filteredGames: any[] = []
        // originalGamesState.forEach((game: any) => {
        //   if (game?.title_kr?.includes(event.target.value)) {
        //     filteredGames.push(game)
        //   }
        // })
        setSearchString(event.target.value)

    // setGamesState(filteredGames)
    }

    const isBrowser = () => typeof window !== "undefined"

    const scrollToTop = () => 
    {
        if (!isBrowser) return

        if (parentDivRef.current) 
        {
            parentDivRef.current.scrollTop = 0
        }
    }

    const onPaging = (page: number) => 
    {
        setPage(page)
    }

    const handleInputChange = (event: any) => 
    {
        setSearchString(event.target.value)
    }

    const handleClearSearch = () => 
    {
        setSearchString("")
    }

    const handleKeyDown = (event: any) => 
    {
        if (event.key === "Enter") 
        {
            setSearchString(event.target.value)
        }
    }

    if (!isClient) 
    {
        return <></>
    }

    return (
        <div className={styles.casinoContainer} ref={parentDivRef}>
            <div className={styles.casino}>
                <div className={styles.textContainer}>
                    <img src='/assets/img/casino_yellow.png'></img>
                    <div className={styles.headingContainer}>
                        <div className={styles.heading}>{t("cassino ao vivo")}</div>
                        <div className={styles.subHeading}>
                            {lobbies?.length +
                " " +
                t(
                    "fornecedores de jogos de cassino ao vivo estão disponíveis."
                )}
                        </div>
                    </div>
                </div>

                <div className={styles.items}>
                    {lobbies?.map(
                        (lobby: any) =>
                            lobby?.status && <CardLive game={lobby} key={lobby.id} />
                    )}
                </div>
            </div>

            <div className={styles.slots}>
                <div className={styles.textContainer}>
                    <img src='/assets/img/slot_yellow.png'></img>
                    <div className={styles.headingContainer}>
                        <div className={styles.heading}>{t("jogos de caça-níqueis")}</div>
                        <div>
                            {t(
                                "Mais de 1.000 slots principais com justiça garantida, classificados por popularidade"
                            )}
                        </div>
                    </div>

                    <div className={styles.fieldsContainter}>
                        {/* <TextField
              placeholder={t('Pesquisa de nome de jogo')}
              InputProps={{
                endAdornment: (
                  <InputAdornment position='end'>
                    <FaSearch />
                  </InputAdornment>
                ),
              }}
              onChange={handleTextFilter}
            /> */}

                        <TextField
                            placeholder={t("Pesquisa de nome de jogo")}
                            value={searchString}
                            onChange={handleInputChange}
                            onKeyDown={handleKeyDown}
                            InputProps={{
                                endAdornment : searchString && (
                                    <IconButton onClick={handleClearSearch}>
                                        <MdClear />
                                    </IconButton>
                                ),
                            }}
                        />
                        <Select
                            className={styles.select}
                            value={selectedProvider}
                            onChange={handleFilter}
                        >
                            <MenuItem value={"default"}>{t("Todos os provedores")}</MenuItem>
                            {providers?.map(
                                (provider: any) =>
                                    provider?.status && (
                                        <MenuItem key={provider.id} value={provider?.name}>
                                            {provider?.name.replaceAll("_", " ")}
                                        </MenuItem>
                                    )
                            )}
                        </Select>
                    </div>

                    {/* {isDesktop && <Select className={styles.select} value={selectedProvider} onChange={handleFilter}>
            <MenuItem value='default'>{t("Todos os provedores")}</MenuItem>
            {providers?.map((provider: any) => (
              provider?.status && (
                <MenuItem key={provider.id} value={provider?.name}>{provider?.name}</MenuItem>
              )
            ))}
          </Select>} */}
                </div>

                {gamesState && gamesState?.length != 0 ? (
                    <div className={styles.itemsSlot}>
                        {gamesState?.map(
                            (game: any) =>
                                game?.status && <CardSlot game={game} key={game.id} />
                        )}
                    </div>
                ) : !init ? (
                    <div className={styles.empty}>{t("Aguarde")}</div>
                ) : (
                    <div className={styles.empty}>{t("Não há jogos no momento")}</div>
                )}
            </div>

            {/* {isVisible && (
        <button className={styles.toTop} onClick={scrollToTop}>
          <FaArrowUp />
        </button>
      )} */}

            <br />
            <PaginationNumber
                total={totalGames}
                page={page}
                perPage={30}
                setPage={setPage}
                onPaging={onPaging}
                infoPages={false}
                gotoPages={true}
            />
            {/* {typeof balance === 'number' && <p><strong>Balance:</strong> ₩{balance}</p>}
        <button onClick={() => callApi(user? user.authToken : null, 'collectAccountGameBalanceAll', { currency: 'KRW' })} type="button">
          collectAccountGameBalanceAll
        </button>
        <button onClick={() => callApi(user? user.authToken : null, 'subtractMemberPointAll', { currency: 'KRW' })} type="button">
          subtractMemberPointAll
        </button>
        <button onClick={() => callApi(user? user.authToken : null, 'addMemberPoint', { amount: 100, currency: 'KRW', transactionId: 3 })} type="button">
          addMemberPoint
        </button>
        <button onClick={() => callApi(user? user.authToken : null, 'getAccountBalanceAllWithTimeout', { currency: 'KRW' })} type="button">
          getAccountBalanceAllWithTimeout
        </button> */}
        </div>
    )
}

async function callApi(
    token: null | string,
    endpoint: string,
    params: any,
    retry: number = 3
): Promise<any> 
{
    const headers: any = {}
    let url: string    = `${process.env.NEXT_PUBLIC_BACKEND_URL}/ximax2`
    url               += "/" + endpoint

    if (params) url += "?" + new URLSearchParams(params)

    if (token !== null) headers["Authorization"] = `Bearer ${token || ""}`

    try 
    {
        const response = await fetch(url, { headers : headers })
        const data     = await response.json()
        console.debug(
            "api response",
            endpoint,
            params,
            "HTTP " + response.status,
            data,
            retry + " retry"
        )

        if (data.returnCode == 21) 
        {
            // Account not found
            if (retry > 0) 
            {
                await callApi(token, "createAccount", null)
                return await callApi(token, endpoint, params, retry - 1)
            }
            else 
            {
                throw new Error("Unable to create account")
            }
        }

        return data
    }
    catch (e) 
    {
        console.error("Error", e)
    }
}

async function getBalance(token: string): Promise<number> 
{
    const result = await callApi(token, "getAccountBalanceAllWithTimeout", {
        currency : "KRW",
    })
    return result.balanceSum
}

// async function getGames() {
//   const games: any = [];
//   const requests = [];
//   const providers = await getProviders();

//   for (const provider of providers)
//     requests.push(callApi(null, 'getGameList', { thirdPartyCode: provider.Code }));

//   const responses = await Promise.all(requests);

//   for (const response of responses) {
//     if(response?.games){
//     for (const providerGame of response?.games)
//       games.push(providerGame);
//   }
// }

//   return games;
// }

async function getGameProviders() 
{
    const result = await collectionDocument(
        CASINO_SETTING.merge({
            perPage : 100,
            where   : [
                {
                    field    : "_level",
                    operator : "==",
                    value    : 1,
                },
                {
                    field    : "status",
                    operator : "==",
                    value    : true,
                },
            ],
        })
    )

    const providers: any[] = []

    if (result?.collection) 
    {
        result?.collection.forEach((item: any) => 
        {
            if (item.id.startsWith("2")) 
            {
                providers.push(item)
            }
        })
    }

    return providers
}

async function getLobbies() 
{
    const result = await collectionDocument(
        CASINO_SETTING.merge({
            perPage : 100,
            where   : [
                {
                    field    : "_level",
                    operator : "==",
                    value    : 2,
                },
                {
                    field    : "type.value",
                    operator : "==",
                    value    : "lobby",
                },
            ],
        })
    )

    if (result?.collection) 
    {
        result?.collection.forEach((item: any) => 
        {
            item.name = item.name.replaceAll("_", " ")
        })
    }

    return result?.collection || []
}

export const getStaticProps: GetStaticProps = ({ locale }) =>
    withHeader(async (props: any) => 
    {
        return {
            props : {
                locale    : locale,
                // balance: await getBalance() || null,
                // games: await getGames() || null,
                lobbies   : (await getLobbies()) || null,
                providers : (await getGameProviders()) || null,
            },
            revalidate : REVALIDATE_SETTING,
        }
    })

export { getStaticProps as GetStaticProps, CasinoPage }
